interface Props {
  used: number
  max: number
  label: string
  unit: string
  color?: string
  warnAt?: number
}

export function CapacityBar({ used, max, label, unit, color = 'var(--primary)', warnAt = 0.8 }: Props) {
  const pct = max > 0 ? used / max : 0
  const barColor = pct > 0.9 ? 'var(--danger)' : pct > warnAt ? 'var(--warning)' : color

  return (
    <div style={{ marginBottom: 10 }}>
      <div className="flex justify-between" style={{ marginBottom: 4 }}>
        <span style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-secondary)' }}>{label}</span>
        <span style={{ fontSize: 12, fontFamily: 'var(--font-mono)', fontWeight: 600, color: pct > warnAt ? barColor : 'var(--text)' }}>
          {used}/{max} {unit}{' '}
          <span style={{ color: 'var(--text-tertiary)', fontWeight: 400 }}>({max - used} free)</span>
        </span>
      </div>
      <div style={{ height: 6, background: 'var(--bg-inset)', borderRadius: 'var(--radius-full)', overflow: 'hidden' }}>
        <div style={{
          height: '100%', width: `${pct * 100}%`,
          background: barColor, borderRadius: 'var(--radius-full)',
          transition: 'width 0.3s ease',
        }} />
      </div>
    </div>
  )
}
